import { defineStore } from "pinia";
import { apoderadosService, } from "@/services/apoderadosService";
import { courseRequiresStudentName } from "@/utils/parseCourseCode";
import { useCursoStore } from "./cursoStore";
const syncSelectedCursoFromCourses = (courses) => {
    const cursoStore = useCursoStore();
    const selected = cursoStore.getCursoData();
    if (!selected)
        return;
    const fresh = courses.find((c) => c.school_id === selected.school_id &&
        String(c.year) === String(selected.year) &&
        String(c.course_id) === String(selected.course_id) &&
        String(c.student_name || "") === String(selected.student_name || "") &&
        String(c.studend_userCourse_seq || c.student_userCourse_seq || "") ===
            String(selected.studend_userCourse_seq ||
                selected.student_userCourse_seq ||
                ""));
    if (!fresh)
        return;
    const needsSync = fresh.cargo_code !== selected.cargo_code ||
        fresh.cargo_label !== selected.cargo_label ||
        fresh.role_code !== selected.role_code ||
        fresh.role_label !== selected.role_label ||
        fresh.assigned_kiosk_id !== selected.assigned_kiosk_id ||
        fresh.entity !== selected.entity ||
        fresh.member_representation !== selected.member_representation ||
        fresh.school_name !== selected.school_name ||
        fresh.course_name !== selected.course_name ||
        fresh.country_code !== selected.country_code ||
        fresh.isExtraGuardian !== selected.isExtraGuardian ||
        fresh.master_user !== selected.master_user ||
        fresh.master_user_name !== selected.master_user_name;
    if (needsSync) {
        cursoStore.setCurso({ ...selected, ...fresh });
    }
};
export const useGuardianStore = defineStore("guardian", {
    state: () => {
        const saved = localStorage.getItem("guardian-store");
        const defaultState = {
            fullName: "",
            rut: "",
            inhabilitiesCertificate: null,
            antecedentsCertificate: null,
            courses: [],
            isIncomplete: false,
            isLoading: false,
        };
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                return { ...defaultState, ...parsed };
            }
            catch (e) {
                console.warn("Error al cargar datos persistidos del guardian:", e);
            }
        }
        return defaultState;
    },
    actions: {
        persistState() {
            const stateToPersist = {
                fullName: this.fullName,
                rut: this.rut,
                inhabilitiesCertificate: this.inhabilitiesCertificate,
                antecedentsCertificate: this.antecedentsCertificate,
                courses: this.courses,
                isIncomplete: this.isIncomplete,
            };
            localStorage.setItem("guardian-store", JSON.stringify(stateToPersist));
        },
        async fetchGuardianData() {
            this.isLoading = true;
            try {
                const guardianData = await apoderadosService.getGuardianWithCourses();
                if (guardianData && guardianData.info) {
                    this.fullName = guardianData.info.full_name || "";
                    this.rut = guardianData.info.rut || "";
                    this.inhabilitiesCertificate =
                        guardianData.info.inhabilities_certificate || null;
                    this.antecedentsCertificate =
                        guardianData.info.antecedents_certificate || null;
                    this.courses = guardianData.courses || [];
                }
                else {
                    this.fullName = "";
                    this.rut = "";
                    this.inhabilitiesCertificate = null;
                    this.antecedentsCertificate = null;
                    this.courses = [];
                }
                this.checkIncomplete();
                syncSelectedCursoFromCourses(this.courses);
                this.persistState();
            }
            catch (e) {
                this.fullName = "";
                this.rut = "";
                this.inhabilitiesCertificate = null;
                this.antecedentsCertificate = null;
                this.courses = [];
                this.isIncomplete = false;
            }
            finally {
                this.isLoading = false;
            }
        },
        checkIncomplete() {
            this.isIncomplete =
                !this.fullName ||
                    this.courses.some((c) => courseRequiresStudentName(c) &&
                        (!c.student_name || c.student_name.trim() === ""));
        },
        setFullName(name) {
            this.fullName = name;
            this.checkIncomplete();
            this.persistState();
        },
        setStudentName(courseIdx, name) {
            if (this.courses[courseIdx]) {
                this.courses[courseIdx].student_name = name;
                this.checkIncomplete();
                this.persistState();
            }
        },
        refreshAfterUpdate() {
            this.fetchGuardianData();
        },
    },
});
